import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { TableContentForFactoryItemApproval } from '../../Common/Table/tableContent';
import services from '../services';
import TextField from '@material-ui/core/TextField';
import $ from 'jquery';
import { Fields, validateProperty, validate, Card } from "../../Common";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { search } from '../../Common';
import { FactoryItemApprovalSchemaObject } from '../FactoryItemApprovalSchema';
import Joi, { object } from '@hapi/joi';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import _, { forEach } from 'lodash';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';

const screenCode = 'FACTORYITEMAPPROVAL'
const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});
export function FactoryItemApprovalListing(props) {

    const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
    const [factoryItems, setfactoryItems] = useState([]);
    const [allFactoryItem, setAllFactoryItem] = useState([])
    const [pageSize, setPageSize] = useState(4)
    const [currentPage, setCurrentPage] = useState(1);
    const [groups, setGroups] = useState();
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [searchForm, setSearchForm] = useState({
        groupID: 0,
        operationEntityID: 0,
        collectionPointID: 0,
        statusID: 1
    });
    const [factories, setFactories] = useState();
    const contentRowNames = ["collectionPointName", "orderNumber", "cardNumber", "createdDate", "statusID"]
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [isTableHidden, setIsTableHidden] = useState(true);
    const classes = useStyles();
    const schema = Joi.object(FactoryItemApprovalSchemaObject).options({ allowUnknown: true })
    const handleLimitChange = (event) => {
        setLimit(event.target.value);
      };
      const handlePageChange = (event, newPage) => {
        setPage(newPage);
      };
    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            FactoryByGroupEntity()
        )
    }, [searchForm.groupID]);

    useEffect(() => {
        trackPromise(
            getCollectionPointsForDropDown()
        )
    }, [searchForm.operationEntityID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFACTORYITEMAPPROVAL');
        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'VIEWFACTORYITEMAPPROVALDETAIL');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });
        var token = tokenService.getUserDetailsFromToken();
        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });
        setGroupDropDownData();
    }

    async function setGroupDropDownData() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await services.getCollectionPointsByOperationentityGroupID(searchForm.operationEntityID, searchForm.groupID);
        setCollectionPoint(collectionPoint);
    }

    function destroyDataTable() {
        setIsTableHidden(true);
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
        setIsTableHidden(false);
    }

    function handleClick(item) {
        props.history.push({
            pathname: 'factoryItemApproval/addEdit',
            data: item,
            edit: true,
            searchForm: searchForm
        })
    }

    function handleGroupChange(e) {
        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value
        const error = { ...errors }
        const errorMessage = validateProperty(target, FactoryItemApprovalSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]
        setSearchForm({
            ...searchForm,
            [e.target.name]: value,
        });
        trackPromise(
            FactoryByGroupEntity(value))
        setErrors(error)
    }

    async function FactoryByGroupEntity() {
        let filteredData = await services.getOperationalEntityByGroupEntityID(searchForm.groupID);
        setFactories(filteredData)
    }

    function handleOperationEntityChange(e) {
        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value
        const error = { ...errors }
        const errorMessage = validateProperty(target, FactoryItemApprovalSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]
        setSearchForm({
            ...searchForm,
            [e.target.name]: value,
        })
        setErrors(error);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, FactoryItemApprovalSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setSearchForm({
            ...searchForm,
            [e.target.name]: value,
        });

        setErrors(error);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    async function handleSearch(e) {
        destroyDataTable();
        const errorMessages = validate(schema, searchForm);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        const result = await services.getFactoryItemApprovalData(searchForm.collectionPointID, searchForm.statusID);
        result.forEach(x => {
            x.createdDate = x.createdDate.split('T')[0];
            x.statusID = x.statusID === 1 ? "New" : x.statusID === 2 ? "Approved" : (x.statusID === 3 ? "Rejected" : "Delivered");

        })

        let lemp2 = _.groupBy(result, 'orderNumber')
        const finalResult = Object.values(lemp2)

        setAllFactoryItem(finalResult);
        createDataTable();

    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Factory Item Approval" />
                        <div className="card-body">
                            <form>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            name="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            value={searchForm.groupID}
                                            onChange={(e) => handleGroupChange(e)}>
                                            <MenuItem value="0">--Select Group Name--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select fullWidth
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            value={searchForm.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="collectionPointID">Collection point *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionPointID"
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={searchForm.collectionPointID}
                                            onChange={(e) => handleOperationEntityChange(e)}>
                                            <MenuItem value="0">--Select Collection point--</MenuItem>
                                            {generateDropDownMenu(collectionPoint)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <TextField select fullWidth
                                            label="Status "
                                            id="statusID"
                                            name="statusID"
                                            value={searchForm.statusID}
                                            type="text"
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Status--</option>
                                            <option value="1">New</option>
                                            <option value="2">Approved</option>
                                        </TextField>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <input
                                            type="button"
                                            className="btn btn-primary"
                                            value="Serach"
                                            onClick={e => trackPromise(handleSearch(e))}
                                        />
                                    </div>
                                </div>
                            </form>
                            <div hidden={isTableHidden} className="table-responsive row-top-gap">
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Collection Point</TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Order No</TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Card Number</TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Requested Date</TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Status</TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Actions</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {allFactoryItem.slice(page * limit, page * limit + limit).map((row, i) => (
                                                <TableRow key={i}>
                                                    <TableCell component="th" scope="row" align="center"> {row[0].collectionPointName}</TableCell>
                                                    <TableCell component="th" scope="row" align="center"> {row[0].orderNumber}</TableCell>
                                                    <TableCell component="th" scope="row" align="center"> {row[0].cardNumber}</TableCell>
                                                    <TableCell component="th" scope="row" align="center"> {row[0].createdDate}</TableCell>
                                                    <TableCell component="th" scope="row" align="center"> {row[0].statusID}</TableCell>
                                                    <TableCell align="center">
                                                        <IconButton aria-label="delete" className={classes.margin} onClick={e => handleClick(row[0])}>
                                                            <EditIcon fontSize="small" />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                            )}

                                        </TableBody>
                                        
                                    </Table>
                                    <TablePagination
                                            component="div"
                                            count={allFactoryItem.length}
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handleLimitChange}
                                            page={page}
                                            rowsPerPage={limit}
                                            rowsPerPageOptions={[5, 10, 25]}
                                        />
                                </TableContainer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}